import { apiSlice } from '../apiSlice';
import { MESSAGES } from './missedQuestionsMessages';
import handleBlobTypes from '../utils/handleBlobTypes';
import { API_TAGS } from '../../constants/api';

export const missedQuestionsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchMissedQuestions: builder.query({
      query: ({ orgId, urlParams = {} }) => ({
        url: `organizations/${orgId}/missed-questions`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_MISSED_QUESTIONS.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        if (error?.error) {
          return [{ type: API_TAGS.MISSED_QUESTIONS, id: 'LIST' }];
        }
        return [
          ...result.items.map(({ id }) => ({ type: API_TAGS.MISSED_QUESTIONS, id })),
          { type: API_TAGS.MISSED_QUESTIONS, id: 'LIST' }
        ];
      }
    }),
    fetchMissedQuestionOccurrences: builder.query({
      query: ({ orgId, missedQuestionId, urlParams = {} }) => ({
        url: `organizations/${orgId}/missed-questions/${missedQuestionId}/occurrences`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_MISSED_QUESTIONS.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.BOTS, id: args.missedQuestionId }];
      }
    }),

    // TODO: This endpoint is not used yet
    downloadMissedQuestions: builder.query({
      query: ({ orgId, urlParams = {} }) => ({
        url: `organizations/${orgId}/missed-questions/export`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.DOWNLOAD_MISSED_QUESTIONS.ERROR
        },
        responseType: 'blob',
        includeResponseHeaders: true
      }),
      providesTags: (result, error, args) => {
        return [
          { type: API_TAGS.MISSED_QUESTIONS, id: 'LIST' }
        ];
      },
      transformResponse: (response) => {
        return handleBlobTypes(response);
      }
    })
  })
});

export const {
  useFetchMissedQuestionsQuery,
  useFetchMissedQuestionOccurrencesQuery,
  useLazyFetchMissedQuestionsQuery,
  useLazyDownloadMissedQuestionsQuery
} = missedQuestionsSlice;
